import React, { useState, useEffect, useCallback, useRef } from "react";
import { popupDirections } from "../../utils/consts";
import Button from "../Button";
import { Icon } from "@iconify/react";
import ProgressBar from "../ProgressBar";
import { ReactComponent as DoneSvg } from "../../assets/svg/done.svg";
import PopupInfoContainer from "../../templates/PopupInfoContainer";
import { motion } from "framer-motion";
import "../../css/user-dinosaur-about.css";

const UserDinosaurAbout = (props) => {
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [data, setData] = useState(props.data || {});
  const [isUp, setIsUp] = useState(false);

  const containerRef = useRef(null);
  const contentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsAboutOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Проверка размещения меню
  const checkDropdownPosition = useCallback(() => {
    if (containerRef.current && contentRef.current) {
      const dropdownRect = containerRef.current.getBoundingClientRect(); // Положение dropdown
      const contentRect = contentRef.current.getBoundingClientRect(); // Положение content
      const pageHeight = document.documentElement.scrollHeight; // Высота всей страницы

      // Если контент снизу, проверяем, влезает ли он вниз страницы
      if (!isUp) {
        const dropdownBottom = contentRect.bottom + window.scrollY;
        const dropdownTop =
          dropdownRect.top + window.scrollY - contentRect.height;

        if (dropdownBottom > pageHeight && dropdownTop > 0) {
          // Если не помещается вниз и влезает вверх, показываем вверх
          setIsUp(true);
        }
      }

      // Если контент сверху, проверяем, влезает ли он вниз страницы или вверх
      else if (isUp) {
        const dropdownBottom =
          dropdownRect.bottom + window.scrollY + contentRect.height;
        const dropdownTop = window.scrollY + contentRect.top;

        if (dropdownBottom <= pageHeight || dropdownTop < 0) {
          setIsUp(false);
        }
      }
    }
  }, [isUp]);

  const toggleDropdown = () => {
    setIsAboutOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isAboutOpen) {
      checkDropdownPosition(); // Проверка при клике
    }
  }, [isAboutOpen, checkDropdownPosition]);

  return (
    <div
      ref={containerRef}
      className={`user-dinosaur-about${isUp ? " up" : ""}`}
    >
      <div className="user-dinosaur-about-buttons">
        <Button className="rectangled extra">Активировать</Button>
        <Button className="rectangled" onClick={toggleDropdown}>
          <Icon icon="zondicons:dots-horizontal-triple" />
        </Button>
      </div>
      {isAboutOpen && (
        <motion.div
          ref={contentRef}
          className="user-dinosaur-about-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="dinosaur-icon-info">
            <div className="dinosaur-health">
              <Icon icon="map:health" className="health-icon" />
              <ProgressBar value={350} max={350} />
            </div>
            <div className="dinosaur-icon-info-icons d-flex flex-wrap justify-around">
              <div className="dinosaur-icon-info-icon">
                <Icon icon="mingcute:lightning-fill" className="storm-icon" />
                <p>100%</p>
              </div>
              <div className="dinosaur-icon-info-icon">
                <Icon icon="fluent:food-20-regular" className="food-icon" />
                <p>100%</p>
              </div>
              <div className="dinosaur-icon-info-icon">
                <Icon icon="ion:water" className="water-icon" />
                <p>100%</p>
              </div>
              <div className="dinosaur-icon-info-icon">
                <Icon icon="ion:water" className="blood-icon" />
                <p>0</p>
              </div>
            </div>
          </div>
          <div className="dinosaur-about-menu">
            <div className="dinosaur-about-menu-item dinosaur-about-limit text-dangerous">
              <p>Лимит в группе: безлимит (джуви)</p>
            </div>
            <div className="dinosaur-about-menu-item dinosaur-about-spawn text-success">
              <DoneSvg className="svg-success" />
              <span>Доступен спавн</span>
            </div>
            <div className="dinosaur-about-menu-item">
              <button className="w-100">Купить воскрешения</button>
            </div>
            <div className="dinosaur-about-menu-item">
              <button className="w-100">Сменить скин</button>
            </div>
            <div className="dinosaur-about-menu-item">
              <button className="w-100">Сменить пол</button>
            </div>
            <div className="dinosaur-about-menu-item">
              <button className="w-100 text-dangerous">Удалить</button>
            </div>
            <div className="dinosaur-about-menu-item">
              <PopupInfoContainer
                value={"Информация о динозавре"}
                direction={popupDirections.right}
              >
                <div className="dinosaur-about-menu">
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>Добавлен</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.buyTime}
                    </span>
                  </div>
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>Источник появления</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.appearance}
                    </span>
                  </div>
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>Обновлен</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.updateTime}
                    </span>
                  </div>
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>Геном</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.genom}
                    </span>
                  </div>
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>Особенность</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.feature}
                    </span>
                  </div>
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>Координаты</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.coordinates}
                    </span>
                  </div>
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>ID динозавра</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.itemId}
                    </span>
                  </div>
                  <div className="dinosaur-about-menu-item d-flex justify-between gap-1">
                    <span>ID слота</span>
                    <span className="dinosaur-about-menu-item-info">
                      {data.slotId}
                    </span>
                  </div>
                </div>
              </PopupInfoContainer>
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default UserDinosaurAbout;
